import { Badge } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  BREACK_POINT_HEADER,
  PHONE_CONTACT,
  PROPERTY_TYPE,
  ROUTER_PATH,
} from "../../common/constant";
import {
  checkTagPromotionForSpecialMattress,
  getDiscountName,
  getImageOrVideoPath,
  getMediaUrl,
  getPriceDisplay,
  localizeRouteKey,
} from "../../shared/helpers";
import CoverSelect, { ICoverSelectProps } from "./coverSelect";
import DeskSelect, { IDeskSelectProps } from "./deskSelect";
import FeatureSelect, { IFeatureSelectProps } from "./featureSelect";
import FoamSelect, { IFoamSelectProps } from "./foamSelect";
import ProductItemGiftModal from "./giftModal";
import "./style.scss";
import * as GTM from "../tracking/GTM";
import {
  IconProductPromotion,
  IconProductSecialMattressPromotion,
} from "../images";
import { selectGift } from "../../redux/reducers/slice/common";
import { useSelector } from "react-redux";
import { sortBy } from "lodash";
import { products } from "../../repositories";

interface IProductItemComponentProps {
  productId?: string;
  productPath?: string;
  productFoam?: number | null;
  productSpecCode?: string;
  img?: string;
  name?: string;
  category_name?: string;
  featureCode: string;
  pattern_name?: string;
  features?: IFeatureSelectProps;
  foams?: IFoamSelectProps | null;
  covers?: ICoverSelectProps | null;
  desk?: IDeskSelectProps | null;
  price?: string;
  price_promotion?: string;
  discount_percent?: string;
  price_installment?: string | number;
  info_promotion?: IInfoPromotion;
  quantity: number;
  addToCart: Function;
  decreaseQuantity: Function;
  increaseQuantity: Function;
  resetQuantity: Function;
  isHaveMoreGift: boolean;
  isNeedCompare: boolean;
  isInCompareList: boolean | null;
  isNeedContact?: boolean;
  addToCompare: (gifts: any) => void | null;
  removeFromCompare: () => void | null;
  renderWishButton: () => React.ReactNode;
}

interface IInfoPromotion {
  name?: string;
  from?: string;
  to?: string;
}

const ProductItemComponent = (props: IProductItemComponentProps) => {
  const gift = useSelector(selectGift);
  const {
    productId,
    productPath,
    productFoam,
    productSpecCode,
    name,
    featureCode,
    pattern_name,
    img,
    features,
    foams,
    covers,
    desk,
    price,
    price_promotion,
    discount_percent,
    price_installment,
    info_promotion,
    quantity,
    addToCart,
    decreaseQuantity,
    increaseQuantity,
    resetQuantity,
    isHaveMoreGift,
    isNeedCompare,
    isInCompareList,
    isNeedContact,
    addToCompare,
    removeFromCompare,
    renderWishButton,
    category_name,
  } = props;

  const [visibleGiftModal, setVisibleGiftModal] = useState(false);
  const [discountPromotion, setDiscountPromotion] = useState(null);
  const [discountPrice, setDiscountPrice] = useState(null);
  const [gifts, setGifts] = useState([]);

  useEffect(() => {
    const _gifts =
      (features?.currentValue && features?.currentValue.promotion_products) ||
      [];

    setGifts(_gifts);
    resetQuantity(1);
    setDiscountPrice(null);
  }, [featureCode]);

  const { t } = useTranslation();

  const _icons =
    gift && gift.children && gift.children.length
      ? sortBy(gift.children, ["order"])
      : null;

  const _iconProductPromotion = _icons
    ? getImageOrVideoPath(_icons[0].images)
    : IconProductPromotion;
  const _iconProductSecialMattressPromotion = _icons
    ? getImageOrVideoPath(_icons[1].images)
    : IconProductSecialMattressPromotion;

  const openGiftModal = async () => {
    await getPromotionProducts(quantity);
    setVisibleGiftModal(true);
  };
  const closeGiftModal = () => {
    setVisibleGiftModal(false);
  };

  const getPromotionProducts = async (qty: number) => {
    if (!pattern_name) {
      // Khong phai drap thi moi getPromotions
      const rs = await products.getProductPromotion({
        code: featureCode,
        quantity: qty,
      });

      if (
        rs &&
        rs.data &&
        rs.data.promotion_products &&
        rs.data.promotion_products.length
      ) {
        setGifts(rs.data.promotion_products);
      }

      if (
        rs &&
        rs.data &&
        rs.data.promotion_discounts &&
        rs.data.promotion_discounts.length
      ) {
        setDiscountPromotion(
          rs.data.promotion_discounts[0].promotion_group_apply_name
        );
        setDiscountPrice(rs.data.promotion_discounts[0].extra_discounted_price);
      }
    }
  };

  const getGiftTotalQuantity = () =>
    gifts.reduce((cur, { quantity }) => {
      return cur + quantity;
    }, 0);

  const addToCartWithEffect = async () => {
    const { parentNode, index } = await addToCart();

    if (!parentNode) return;

    let imgToDrag = parentNode.querySelectorAll(".product-item")[index];

    if (!imgToDrag) return;

    const classNameViewCart =
      window.innerWidth > BREACK_POINT_HEADER
        ? "kd-shopping-cart"
        : "kd-shopping-cart-mobile";

    let viewCart: any = document.getElementsByClassName(classNameViewCart)[0];

    viewCart.style = "";

    let imgToDragImage = imgToDrag.querySelector(".product-item__avatar");

    let disLeft = imgToDrag.getBoundingClientRect().left;
    let disTop = imgToDrag.getBoundingClientRect().top;
    let cartleft = viewCart.getBoundingClientRect().left;
    let carttop = viewCart.getBoundingClientRect().top;
    let image: any = imgToDragImage?.cloneNode(true);

    image.style =
      "z-index: 1111; width: 100px;opacity:0.9; position:fixed; top:" +
      disTop +
      "px;left:" +
      disLeft +
      "px;transition: left 1s, top 1s, width 1s, opacity 1s cubic-bezier(1, 1, 1, 1)";
    var rechange = document.body.appendChild(image);

    setTimeout(function () {
      image.style.left = cartleft + "px";
      image.style.top = carttop + "px";
      image.style.width = "40px";
      image.style.opacity = "0";
    }, 200);
    setTimeout(function () {
      viewCart.style = "animation: shake 0.2s";
      rechange.parentNode.removeChild(rechange);
    }, 1000);
  };

  const handleClickViewProduct = () => {
    const _price = price ? parseInt(price?.replaceAll(".", "")) : 0;
    const _unit_price = price_promotion
      ? parseInt(price_promotion?.replaceAll(".", ""))
      : 0;
    GTM.trackingProductClick({
      id: featureCode,
      name: `${name}`,
      category: category_name ? category_name : "",
      price: _price,
      quantity: 1,
      discount_price: _price - _unit_price,
      promotion: "",
      subtotal_amount: _unit_price * 1,
      unit_price: _unit_price,
    });
  };

  const hiddenSizeSpec = () => {
    const productProps = features?.currentValue?.product_props;

    if (!productProps || !productProps.length) {
      return false;
    }

    const size = productProps.find(
      (item: any) => item.code === PROPERTY_TYPE.size_drap
    );

    if (!size) {
      return false;
    }

    return !!size?.is_hidden;
  };

  return (
    <>
      <div className="product-item">
        <Link
          style={{ pointerEvents: !isNeedContact ? "initial" : "none" }}
          to={{
            pathname: !isNeedContact
              ? localizeRouteKey(ROUTER_PATH.PRODUCT_DETAIL) +
                `/${productPath}/${featureCode}${
                  productFoam
                    ? `?foam=${productFoam}`
                    : productSpecCode
                      ? `?spec=${productSpecCode}`
                      : ""
                }`
              : undefined,
            state: {
              product_id: productId,
              product_code: featureCode,
              product_foam: productFoam,
              product_spec_code: productSpecCode,
            },
          }}
          onClick={handleClickViewProduct}>
          <div className="product-item__avatar">
            <img src={getMediaUrl(img || "")} alt="" />
          </div>
        </Link>

        {renderWishButton()}

        {isHaveMoreGift && (
          <div className="product-item__gift-more">
            <img
              src={
                checkTagPromotionForSpecialMattress(productId)
                  ? _iconProductSecialMattressPromotion
                  : _iconProductPromotion
              }
              alt=""
            />
          </div>
        )}

        {isNeedCompare && !isNeedContact && (
          <div
            className="product-item-compare-button"
            onClick={() =>
              !isInCompareList ? addToCompare(gifts) : removeFromCompare()
            }>
            <div className="product-item-compare-button__icon">
              <img
                src={
                  !isInCompareList
                    ? "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_compare-81-82.svg"
                    : "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_compare-82.svg"
                }
                alt=""
              />
            </div>
            <span
              className={`product-item-compare-button__text ${
                !isInCompareList
                  ? ""
                  : "product-item-compare-button__text--added"
              } sub-content`}>
              {!isInCompareList ? "So sánh" : "Đã thêm so sánh"}
            </span>
          </div>
        )}

        <div className="product-item__property">
          <Link
            style={{ pointerEvents: !isNeedContact ? "initial" : "none" }}
            to={{
              pathname: !isNeedContact
                ? localizeRouteKey(ROUTER_PATH.PRODUCT_DETAIL) +
                  `/${productPath}/${featureCode}${
                    productFoam ? `?foam=${productFoam}` : ""
                  }`
                : undefined,
              state: {
                product_id: productId,
                product_code: featureCode,
                product_foam: productFoam,
                product_spec_code: productSpecCode,
              },
            }}
            onClick={handleClickViewProduct}>
            <p className="main-content product-item__name">{name}</p>
          </Link>
          {pattern_name ? (
            <p className="product-item__pattern-name">{pattern_name}</p>
          ) : null}
          <div className="list-properties">
            {desk && (
              <DeskSelect {...desk} currentFeature={features?.currentValue} />
            )}
            {covers && <CoverSelect {...covers} />}
            {foams && <FoamSelect {...foams} />}
            {features && !hiddenSizeSpec() && <FeatureSelect {...features} />}
          </div>
        </div>

        {!isNeedContact ? (
          <div className="product-item-info">
            <div className="product-item-info-price">
              <p className="sub-title product-item__price-promotion">
                {discountPrice
                  ? parseInt(discountPrice).toLocaleString("vi-VN")
                  : price_promotion}{" "}
                VND
              </p>
              <p className="sub-content">
                <span className="product-item__discount-percent">
                  {getDiscountName(
                    price,
                    price_promotion,
                    discountPromotion || discount_percent
                  )}
                </span>
                <span className="product-item__price">
                  {getPriceDisplay(price, price_promotion)}
                </span>
              </p>

              <div className="product-item-installment">
                {Array.isArray(gifts) && gifts.length ? (
                  <div className="product-item__gifts" onClick={openGiftModal}>
                    <Badge count={getGiftTotalQuantity()} size="small">
                      <div className="product-item__gifts-icon"></div>
                    </Badge>
                  </div>
                ) : (
                  <div className="product-item__gifts--display-none" />
                )}
                <div className="sub-content product-item__installment">
                  {price_installment !== 0 ? (
                    <p>
                      {t("label_installment_full")}{" "}
                      <span className="product-item__installment-value">
                        ({price_installment || ""}
                        {` vnd/${t("label_month_unit")}`})
                      </span>
                    </p>
                  ) : (
                    <>
                      <p>
                        {info_promotion?.name}{" "}
                        <span className="product-item__installment-value">{`Từ ${info_promotion?.from} đến ${info_promotion?.to}`}</span>
                      </p>
                    </>
                  )}
                  <p>(Giá đã bao gồm VAT)</p>
                </div>
              </div>
            </div>

            <div className="product-item__add-to-cart">
              <div className="product-item__quantity">
                <button
                  className="quantity-button"
                  disabled={quantity === 1}
                  onClick={() => decreaseQuantity(getPromotionProducts)}>
                  -
                </button>
                <span className="main-content">{quantity}</span>
                <button
                  className="quantity-button"
                  disabled={quantity === 100}
                  onClick={() => increaseQuantity(getPromotionProducts)}>
                  +
                </button>
              </div>
              <div
                onClick={addToCartWithEffect}
                className="product-item__button-add-to-cart">
                <img
                  src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_cart-49.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="product-item-contact-info">
            <span className="sub-content">{t("label_customer_demand")}</span>
            <span className="sub-content product-item-contact-info__contact">
              {t("label_contact")}
              <a href={`tel:${PHONE_CONTACT}`}>{PHONE_CONTACT}</a>
            </span>
          </div>
        )}
      </div>

      <ProductItemGiftModal
        quantity={quantity}
        visible={visibleGiftModal}
        closeGiftModal={closeGiftModal}
        gifts={gifts || []}
      />
    </>
  );
};

export default ProductItemComponent;
